jQuery(function ($) {
    // Use global shared function from main.js if available, otherwise fallback to local
    const loadValidationScript = window.loadValidationScript || function(callback) {
        if (window.InputValidator) {
            if (typeof callback === 'function') callback();
        } else if (window._validationScriptLoading) {
            const checkInterval = setInterval(function() {
                if (window.InputValidator) {
                    clearInterval(checkInterval);
                    delete window._validationScriptLoading;
                    if (typeof callback === 'function') callback();
                }
            }, 50);
        } else {
            window._validationScriptLoading = true;
            $.getScript("/assets/frontend/js/validation.js", function() {
                delete window._validationScriptLoading;
                if (typeof callback === 'function') callback();
            });
        }
    };
    
    loadValidationScript(function () {
        const registrationParent = $("body");
        const registrationForm = $(".registration-form");
        const registrationPreloader = $(".registration-form-preloader");
        const registrationWarningBox = $(".registration-warning-messages");
        const registrationGeneralWarning = $(".registration-message-warning-general");

        let registrationFormRunner = true;

        const resetRegistrationState = function() {
            registrationFormRunner = true;
            registrationPreloader.removeClass("preloader-visible");
        };

        // When company/legal is selected: show "Company name" label and registration number field
        function updateRegistrationFormForUserType() {
            const isLegal = $('input[name="form-registration-user-type"]:checked').val() === 'legal';
            const $form = $('.registration-form');
            const $nameLabel = $('#registration-name-label');
            const $regNumWrap = $('.registration-registration-number-wrapper');
            const labelName = $form.data('label-name') || 'Name *';
            const labelCompanyName = $form.data('label-company-name') || 'Company name *';
            if ($nameLabel.length) {
                $nameLabel.text(isLegal ? labelCompanyName : labelName);
            }
            if ($regNumWrap.length) {
                if (isLegal) {
                    $regNumWrap.removeClass('d-none');
                } else {
                    $regNumWrap.addClass('d-none');
                    $('input[name="form-register-registration-number"]').val('');
                }
            }
        }
        $('input[name="form-registration-user-type"]').on('change', updateRegistrationFormForUserType);
        updateRegistrationFormForUserType();

        const showRegistrationMessage = function(message) {
            if (!message) return;
            registrationGeneralWarning.text(message).show();
            registrationWarningBox.show();
        };

        // Use universal error clearer

        registrationParent.on("submit", ".registration-form", function (e) {
            e.preventDefault();
            if (registrationFormRunner === true) {
                registrationFormRunner = false;
                
                // Clear errors using UniversalHelpers if available, otherwise use fallback
                if (window.UniversalHelpers && window.UniversalHelpers.clearErrors) {
                    window.UniversalHelpers.clearErrors(
                        ".registration-warning-messages",
                        ".registration-form-input-wrapper, .registration-form-input, .registration-input-warning-type, .registration-input-warning-registration-number, .registration-input-warning-privacy-policy",
                        ".registration-warning-messages .single-warning-message"
                    );
                } else {
                    // Fallback error clearing
                    registrationWarningBox.hide();
                    $(".registration-form-input-wrapper, .registration-form-input, .registration-input-warning-type, .registration-input-warning-privacy-policy").removeClass('input-warning');
                    registrationWarningBox.find(".single-warning-message").hide();
                }

                // Hide all warning messages before validation
                registrationWarningBox.find(".single-warning-message").hide();

                // Get form data
                const userTypeSelection = $('input[name="form-registration-user-type"]:checked').val();
                let userType = '';
                if (userTypeSelection === 'individual') {
                    userType = 'private';
                } else if (userTypeSelection === 'legal') {
                    userType = 'business';
                }
                
                let formData = {
                    'form-register-email': $('input[name="form-register-email"]').val(),
                    'form-register-password': $('input[name="form-register-password"]').val(),
                    'form-register-password-confirm': $('input[name="form-register-password-confirm"]').val(),
                    'form-register-name': $('input[name="form-register-name"]').val(),
                    'form-register-phone': $('input[name="form-register-phone"]').val(),
                    'form-register-type': userType,
                    'form-registration-privacy-policy': $('input[name="form-registration-privacy-policy"]').prop('checked') ? 'on' : '',
                    'honeypot': registrationForm.find('input[name="honeypot"]').val() || ''
                };
                if (userType === 'business') {
                    formData['form-register-registration-number'] = $('input[name="form-register-registration-number"]').val();
                }

                registrationPreloader.addClass("preloader-visible");
                const submitRegistration = function(payload) {
                    $.ajax({
                        url: "/profile/register",
                        type: "post",
                        data: payload,
                        dataType: 'json',
                        success: function (response) {
                            resetRegistrationState();

                            // Update CSRF token if provided
                            window.CSRFHelper.updateCSRFMeta(response);

                            if (response.success) {
                                registrationForm.remove();
                                $(".registration-success-submit").removeClass("d-none");
                                let headerHeight = $(".navbar-header").outerHeight();
                                let extraSpace = ($(window).width() > 767) ? 32 : 0;
                                $('html, body').animate({
                                    scrollTop: $(".registration-form-wrapper").offset().top - headerHeight - extraSpace
                                }, 1000);
                            } else {
                                const errors = response && response.errors && typeof response.errors === 'object'
                                    ? response.errors
                                    : null;

                                if (errors && Object.keys(errors).length > 0) {
                                    // Always show the warning block if there are errors
                                    registrationWarningBox.show();
                                    // Map backend error keys to warning message classes
                                    const errorMap = {
                                        'form-register-type': '.registration-message-warning-type',
                                        'form-register-name': '.registration-message-warning-name',
                                        'form-register-registration-number': '.registration-message-warning-registration-number',
                                        'form-register-email': '.registration-message-warning-email',
                                        'form-register-phone': '.registration-message-warning-phone',
                                        'form-register-password': '.registration-message-warning-password',
                                        'form-register-password-confirm': '.registration-message-warning-confirm-password',
                                        'form-registration-privacy-policy': '.registration-message-warning-privacy-policy'
                                    };
                                    Object.entries(errors).forEach(([field, message]) => {
                                        const selector = errorMap[field];
                                        if (selector) {
                                            $(selector).text(message).show();
                                            // Also highlight the input and its wrapper
                                            const $input = $(`[name="${field}"]`);
                                            const $wrapper = $input.closest('.registration-form-input-wrapper');
                                            $input.addClass('input-warning');
                                            $wrapper.addClass('input-warning');
                                        }
                                    });
                                    if (errors['form-register-type']) {
                                        $(".registration-input-warning-type").addClass('input-warning');
                                    }
                                    if (errors['form-registration-privacy-policy']) {
                                        $(".registration-input-warning-privacy-policy").addClass('input-warning');
                                    }
                                } else if (response.message) {
                                    showRegistrationMessage(response.message);
                                } else {
                                    showRegistrationMessage('Sistēmas kļūda. Lūdzu mēģiniet vēlāk.');
                                }
                            }
                        },
                        error: function (xhr) {
                            resetRegistrationState();

                            // Try to update CSRF token from error response if available
                            try {
                                const errorResponse = xhr.responseJSON || {};
                                window.CSRFHelper.updateCSRFMeta(errorResponse);
                            } catch (e) {
                                // Ignore parsing errors
                            }

                            if (xhr.status === 403) {
                                if (window.UniversalHelpers && window.UniversalHelpers.handleCsrfError) {
                                    window.UniversalHelpers.handleCsrfError(".registration-warning-messages");
                                } else {
                                    showRegistrationMessage('Sesijas tokens ir beidzies. Lūdzu atsvaidziniet lapu.');
                                }
                                return;
                            }

                            const errorMessage = xhr.responseJSON && xhr.responseJSON.message
                                ? xhr.responseJSON.message
                                : 'Sistēmas kļūda. Lūdzu mēģiniet vēlāk.';
                            showRegistrationMessage(errorMessage);
                        }
                    });
                };

                const sendRegistration = function() {
                    // Inject CSRF token
                    const payload = window.CSRFHelper.injectCSRF(formData);
                    submitRegistration(payload);
                };

                if (window.CSRFHelper && typeof window.CSRFHelper.refreshCSRFToken === 'function') {
                    window.CSRFHelper.refreshCSRFToken()
                        .then(sendRegistration)
                        .catch(sendRegistration);
                } else {
                    sendRegistration();
                }
            }
        });

        // Password visibility toggle
        /*
        $('.password-visibility-switcher').on('click', function(e) {
            e.preventDefault();            
            let input = $(this).siblings('input');                    
            if (input.attr('type') === 'password') {
                input.attr('type', 'text');
                $(this).addClass('visible');
            } else {
                input.attr('type', 'password');
                $(this).removeClass('visible');
            }
        });
        */
    });
});